
const digest = '8903d4d952556e2b87f802a335832958ee34e6e1a3df5a037d67a1adea558370';
const classes = {"tab":"_tab_bk5uw_1","textTab":"_textTab_bk5uw_5","textTabWithCanvas":"_textTabWithCanvas_bk5uw_10","controls":"_controls_bk5uw_14","controlsColumn":"_controlsColumn_bk5uw_20","sigCanvas":"_sigCanvas_bk5uw_25","uploadPreview":"_uploadPreview_bk5uw_29","signature":"_signature_bk5uw_33","text":"_text_bk5uw_5","image":"_image_bk5uw_43"};
const css = `._tab_bk5uw_1 {
  width: 100%;
}

._textTab_bk5uw_5 {
  text-align: center;
  padding: 40px 0 20px;
}

._textTabWithCanvas_bk5uw_10 {
  padding: 20px;
}

._controls_bk5uw_14 {
  display: flex;
  justify-content: space-between;
  padding-top: 40px;
}

._controlsColumn_bk5uw_20 {
  display: inline-flex;
  flex-direction: column;
}

._sigCanvas_bk5uw_25 {
  border: 1px solid #1665d8;
}

._uploadPreview_bk5uw_29 {
  max-height: 300px;
}

._signature_bk5uw_33 {
  display: flex;
  justify-content: center;
}
._signature_bk5uw_33 ._text_bk5uw_5 {
  text-align: left;
  display: flex;
  align-items: center;
  padding-right: 20px;
}
._signature_bk5uw_33 ._image_bk5uw_43 {
  max-width: 60%;
  padding: 0 40px;
  display: flex;
  align-items: center;
}
._signature_bk5uw_33 ._image_bk5uw_43 img {
  max-width: 100%;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  